<template>
  <div id="decNotice">
    <Head/>
    <div class="decnotice">
       <div class="leftNav">
        <decLeftNav ref="LeftNav" />
      </div>
      <div class="Main">
        <div class="Now">
          <div class="title">最新申报通知</div>
          <declareSon/>
        </div>
        <div class="Past">
          <div class="title">历年申报通知</div>
          <declareSon/>
        </div>
      </div>
    </div>
    <Foot/>
  </div>
</template>
<script>
import Head from '../../components/Head'
import Foot from '../../components/Foot'
import decLeftNav from "../../components/decLeftNav"
import declareSon from "../../components/declareSon"
export default {
  name:"decNotice",
  date(){
    return {

    }
  },
  mounted(){
    if(!sessionStorage.getItem("name")){
      this.$router.replace("/Declare")
    }
    this.$refs.LeftNav.isTable()
  },
  components:{
    Head,Foot,decLeftNav,declareSon
  }
}
</script>
<style lang="less" scoped>
  #decNotice{
    width: 100%;
    min-width: 1000px;
    .decnotice{
      margin-top: 0.4rem;
      width: 100%;
      padding: 0 1.35rem;
      font-size: 0.18rem;
      display: flex;
      align-items: stretch;
      .leftNav {
        padding-right: 0.4rem;
        border-right: 0.01rem solid #e4e4e4;
      }
      .Main{
        width: 13.5rem;
        border: 0.01rem solid #E4E4E4;
        margin-left: 0.5rem;
        padding: 0.15rem;
        .title{
          font-size: 0.15rem;
          margin: 0.15rem 0;
        }
      }
    }
  }
</style>